"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
void i18next_1.default.init({
    fallbackLng: 'en',
    debug: !globalThis.config.IS_PRODUCTION || globalThis.config.IS_SANDBOX,
    interpolation: {
        escapeValue: false,
    },
});
function parseAmount(amount) {
    if (typeof amount === 'number') {
        return amount;
    }
    return Number.parseFloat(amount.replaceAll(',', ''));
}
// formats a number or string as currency
function formatCurrency(amount, currency = 'USD', options = {}) {
    const value = typeof amount === 'string' ? parseAmount(amount) : amount;
    return new Intl.NumberFormat(i18next_1.default.language, {
        style: 'currency',
        currency,
        ...options,
    }).format(value);
}
// formats a number or string without currency symbol
function formatNumber(amount, options = {}) {
    const value = typeof amount === 'string' ? parseAmount(amount) : amount;
    return new Intl.NumberFormat(i18next_1.default.language, {
        useGrouping: true,
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        ...options,
    }).format(value);
}
function getCurrencySymbol(currency = 'USD') {
    return (new Intl.NumberFormat(i18next_1.default.language, {
        style: 'currency',
        currency,
        currencyDisplay: 'symbol',
    })
        .formatToParts(0)
        .find(part => part.type === 'currency')?.value || currency);
}
async function setLanguage(locale) {
    await i18next_1.default.changeLanguage(locale);
}
exports.default = {
    formatCurrency,
    formatNumber,
    getCurrencySymbol,
    parseAmount,
    setLanguage,
    i18next: i18next_1.default,
};
